import '../assets/css/main.css';
import { Link } from 'react-router-dom';

import { Autoplay, FreeMode, EffectCards, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import Count from '../components/Count';
import { TopButton } from "../components/TopButton"
import { Floating } from "../components/Floating"

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import 'swiper/css/free-mode';
import 'swiper/css/effect-cards';

import { useRef, useEffect } from 'react';
import { gsap } from "gsap";
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { LuYoutube } from "react-icons/lu";

import { ReactComponent as Bell } from '../assets/images/link-bell.svg'
import { ReactComponent as Scroll } from '../assets/images/icon-mouse.svg'
import { ReactComponent as Pointer } from '../assets/images/icon-pointer.svg'

export default function MainPage() {

  useEffect(()=>{
    const titleElement = document.getElementsByTagName('title')[0];
    titleElement.innerHTML = `어르신본죽왔어요`;
  },[]);

  // 인터렉션 관련 로직

  gsap.registerPlugin(useGSAP, ScrollTrigger);
  const container = useRef();

  useGSAP(() => {
    let tl01 = gsap.timeline({
      default:{duration: 0.1},
      scrollTrigger: {
        trigger: "#video",
      },
    }); // 인트로

    let tl02 = gsap.timeline({
      default:{duration: 0.1},
      scrollTrigger: {
        trigger: "#photocard",
        start: 'top 600',
      },
    }); // 포토카드

    let tl03 = gsap.timeline({
      default:{duration: 0.1},
      scrollTrigger: {
        trigger: "#count",
        start: 'top 400',
      },
    }); // 누적나눔

    let tl04 = gsap.timeline({
      default:{duration: 0.1},
      scrollTrigger: {
        trigger: "#progress",
        start: 'top 400',
      },
    }); // 진행방법

    let tl05 = gsap.timeline({
      default:{duration: 0.1},
      scrollTrigger: {
        trigger: "#story",
        start: 'top 400',
      },
    }); // 나눔스토리

    gsap.fromTo('.scroll', { opacity: 1 }, { opacity: 0, y: 30, repeat: 2, duration: 1 })
    gsap.to('.pointer', { opacity: 0 })

    tl01.from('.motiona1', { opacity: 0, y: 100, })
        .from('.motiona2', { opacity: 0, y: 100, })

    tl02.from('.motionb1', { opacity: 0,  })
        .from('.motionb2', { opacity: 0,  })
        .from('.motionb3', { opacity: 0,  })
        .from('.motionb4', { opacity: 0, rotate: 10 })
        .fromTo('.pointer', { opacity: 1 }, { opacity: 0, x: -200, rotate: 10, repeat: 1, duration: 1.5 })

    tl03.from('.motionc1', { opacity: 0, y: 100, })
        .from('.motionc4', { opacity: 0, y: 100, })

    tl04.from('.motiond1', { opacity: 0, y: 100, })
        .from('.motiond2', { opacity: 0, x: -50, })
        .from('.motiond3', { opacity: 0, x: -100, })
        .from('.motiond4', { opacity: 0, x: -50, })
        .from('.motiond5', { opacity: 0, x: -100, })
        .from('.motiond6', { opacity: 0, x: -50, })
        .from('.motiond7', { opacity: 0, x: -100, }).timeScale(1.18)

    tl05.from('.motione1', { opacity: 0, y: 100, })
        .from('.motione2', { opacity: 0, y: 100, })
        .from('.motione3', { opacity: 0, y: 100, })

  }, { scope: container });

  const STYLES = { 
    videoIframeContainer: { width: '100%', padding: '39.7% 0 0 0', position: 'relative', }, 
    videoIframe: { position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' } 
  }
  const VIDEO_URL = 'https://player.vimeo.com/video/1030638426?controls=0&muted=1&autoplay=1&loop=1&badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
 
  const STYLES_MO = { 
    videoIframeContainer: { width: '100%', padding: '139.7% 0 0 0', position: 'relative', }, 
    videoIframe: { position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' } 
  }
  const VIDEO_URL_MO = 'https://player.vimeo.com/video/1030647840?controls=0&muted=1&autoplay=1&loop=1&badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'

  return (
    <article ref={container}>
      
      <TopButton />
      <Floating /> 
      

      <Scroll 
          className='scroll'
        />
      <section id='video' className=''>
        <div className='video-pc' style={STYLES.videoIframeContainer}>
          <iframe
            title="vimeo-player"
            src={VIDEO_URL}
            
            style={STYLES.videoIframe}
          >
          </iframe>
        </div>

        <div className='video-mo' style={STYLES_MO.videoIframeContainer}>
          <iframe
            title="vimeo-player"
            src={VIDEO_URL_MO}
            
            style={STYLES_MO.videoIframe}
          >
          </iframe>
        </div>

        <div className='video-title'>
          <p className='motiona1'>본죽, 본죽&비빔밥 대표 사회공헌</p>
          <h2 className='motiona2'>어르신 본죽 왔어요</h2>
        </div>
        <Link className='youtube' to="https://youtu.be/i6EY9mV431U?si=CkWeUKZUAxRSDqqz" target="_blank"><LuYoutube className='icon-youtube' />풀버전보기</Link>
      </section>

      <section id='photocard' className='section bggradation'>
        <div>
          <p className='motionb1'>홀로 계신 어르신들을 위해</p>
          <p className='motionb2'>건강한 식사를 나누어</p>
          <p className='motionb3'><b id="point">따뜻한 마음의 안부</b>를 전합니다.</p>
        </div>
        <div id='photos'>
          <Pointer 
            className='pointer'
          />
          <Swiper
            effect={'cards'}
            grabCursor={true}
            modules={[EffectCards, Navigation]}
            className="my-swiper motionb4"
            navigation={true}
          >
            <SwiperSlide className="main-slide1"></SwiperSlide>
            <SwiperSlide className="main-slide2"></SwiperSlide>
            <SwiperSlide className="main-slide3"></SwiperSlide>
            <SwiperSlide className="main-slide4"></SwiperSlide>
          </Swiper>
        </div>
      </section>

      <section id="count" className='section text-center'>
        <h3 className='motionc1'>'어르신 본죽 왔어요'의 따뜻한 결실입니다</h3>
        <div className='motionc3'>
          <Count />
        </div>
        <div className='motionc4'>
          <Link to="/history">
            <button className='btn-light'>
              자세히보기
            </button>
          </Link>
        </div>
      </section>

      <section id="progress" className='section text-center'>
        <h3 className='motiond1'>어르신을 위한 본죽 나눔은 이렇게 진행됩니다</h3>
        <div className='inner flex flex-between flex-wrap'>
          <div className="progress01">
            <h6 className='motiond2'>STEP 01</h6>
            <div className='motiond3'>
              <div></div>
              <p>가맹점에서 정성껏 죽을 만들어요</p>
            </div>
          </div>

          <div className="progress02">
            <h6 className='motiond4'>STEP 02</h6>
            <div className='motiond5'>
              <div></div>
              <p>복지기관에서 어르신께 전할 죽을 픽업해요</p>
            </div>
          </div>

          <div className="progress03">
            <h6 className='motiond6'>STEP 03</h6>
            <div className='motiond7'>
              <div></div>
              <p>어르신께 죽을 전달하며 안부를 여쭙고 마음을 나눠요</p>
            </div>
          </div>
        </div>

      </section>

      <section id="story" className='section text-center'>
        <h3 className='motione1'>나눔 스토리</h3>
        <div className='motione2'>
          <Swiper
            modules={[Autoplay, FreeMode]}
            spaceBetween={30}
            slidesPerView={'auto'}
            freeMode={true}
            autoplay={{
              delay: 0,
              desableOnInteraction: false, 
            }}
            loop={true}
            speed={8e3}
            className="story-swiper"

          >
            <SwiperSlide
              className="story-slide1"
            >        
              <div>
                <p>우리 어르신은 본죽드시며 기력도 회복하셔서 텃밭도 가꾸시고 텃밭 채소로 반찬도 해드신다고 해요.<br />
                <span className='highlight'>‘맛있는 본죽 먹고 이제는 힘도 나고 아프지 않아서 백수도 하겠다’</span>시며 환하게 웃는 모습을 보니 행복합니다.</p>
                <b>창녕군 복지기관 생활지원사</b>
              </div>
            </SwiperSlide>
            <SwiperSlide
              className="story-slide2"
            >
              <div>
                <p>처음 어르신과의 만남은 딱딱하고 거칠었지만 ‘본죽‘ 한 그릇의 인연이 뭉근하게 이어져 부드러움으로 바뀌었습니다. <span className='highlight'>매주 바뀌는 영양 가득한 죽 한 그릇</span>이 어르신과 거리를 좁히고 서서히 스며들도록 하였습니다. </p>
                <b>음성군 복지기관 생활지원사</b>
                <Link to="https://www.youtube.com/watch?v=4uqYVNSDRtM" target="_blank">
                    <Bell className='bell' />
                </Link>
              </div>
            </SwiperSlide>
            <SwiperSlide
              className="story-slide3"
            >
              <div>
                <p>한 두 번 가져오고 안 올 줄 알았는데, 이렇게 다양한 메뉴로 매주 가져다주니 <span className='highlight'>다음에 어떤 죽이 올지 기대가 되고 기다려진다니까.</span> 죽이 너무도 맛있어 힘이 나고 기운도 나고 정말 세상 살 맛 난다. 고맙다, 고마워!</p>
                <b>강** 어르신</b>
              </div>
            </SwiperSlide>
            <SwiperSlide
              className="story-slide4"
            >
              <div>
                <p>가맹점에 죽을 픽업하러 갈때마다 웃으면서 반겨주시고 어르신이 잘 드시는지 입맛에 맞으시는지 물어봐 주시는 <span className='highlight'>따뜻한 마음</span>에 감사드려요.</p>
                <b>부산 복지기관 사회복지사 </b>
              </div>
            </SwiperSlide>

            <SwiperSlide
              className="story-slide6"
            >
              <div>
                <p>종일 누워 있어도 연락 오는 사람 한 명 없고, 이렇게 죽는구나 생각만 들었는데, 선생님 가져오신 죽을 먹고 힘을 내어 병원 진료를 받고 왔어요. <span className='highlight'>죽 한 그릇이 저의 생명을 살리는 죽이었어요.</span> 몸이 아픈 시기에 버틸 수 있는 힘이 되었습니다.</p>
                <b>김** 어르신</b>
              </div>
            </SwiperSlide>
            <SwiperSlide
              className="story-slide7"
            >
              <div>
                <p>본죽을 나누기 위해 매주 방문하며 점차 관계가 형성되어 단순히 죽을 주고 받는 사이에서 오늘 하루 이야기를 나누는 사람, 기다려주는 사람, 보고픈 사람으로 바뀌었습니다. <span className='highlight'>죽과 함께 행복해하시는 모습을 보면 저도 행복해집니다.</span></p>
                <b>공주시 복지기관 사회복지사</b>
              </div>
            </SwiperSlide>
            <SwiperSlide
              className="story-slide8"
            >
              <div>
                <p>정서적으로 고립되어 있는 어르신들에게 본죽으로 따듯한 온정을 전달드릴 수 있었습니다. 외롭고 찾아주는 이 없는 어르신에게는 <span className='highlight'>본죽이 최고의 손님</span>이었습니다.</p>
                <b>거제시 복지기관 사회복지사</b>
              </div>
            </SwiperSlide>
            
          </Swiper>
        </div >
        <div className='motione3'>
            <Link to="/story">
              <button className='btn-dark'>
                자세히보기
              </button>
            </Link>
        </div>
      </section>

    </article>
  );
};
